import {
  DiagnocoinBatch,
  DiagnocoinBatchStatus,
} from 'protocol/api/billing_new/dto_diagnocoin_new_pb';

// Mirrors billing's spendable-batch rule: coins held by pending reports and
// expired coins can never be adjusted out.
export const canAdjustDiagnocoinBatch = (
  batch: DiagnocoinBatch,
  now: Date,
): boolean => {
  const expiresAt = batch.ExpiresAt?.toDate();

  return (
    batch.Status === DiagnocoinBatchStatus.DiagnocoinBatchStatusOpen &&
    expiresAt !== undefined &&
    expiresAt > now &&
    Number(batch.Available ?? 0) > 0
  );
};
